// extracted by mini-css-extract-plugin
export default {"card":"j1-z"};